import { atom } from 'jotai';

import { Organisation } from '~features/organisations';

const organisationAtom = atom<Organisation | undefined | null>();

export default organisationAtom;
